export default `
/*
  Warnings:

  - Made the column \`file_revision_id\` on table \`RawFile\` required. This step will fail if there are existing NULL values in that column.
  - Added the required column \`created_by\` to the \`RawProject\` table without a default value. This is not possible if the table is not empty.
  - Added the required column \`full_path\` to the \`RawProject\` table without a default value. This is not possible if the table is not empty.
  - Added the required column \`project_id\` to the \`RawProject\` table without a default value. This is not possible if the table is not empty.
  - Added the required column \`system\` to the \`RawProject\` table without a default value. This is not possible if the table is not empty.
  - Added the required column \`created_by\` to the \`RawWorkspace\` table without a default value. This is not possible if the table is not empty.
  - Added the required column \`full_path\` to the \`RawWorkspace\` table without a default value. This is not possible if the table is not empty.
  - Added the required column \`system\` to the \`RawWorkspace\` table without a default value. This is not possible if the table is not empty.

*/
-- RedefineTables
PRAGMA defer_foreign_keys=ON;
PRAGMA foreign_keys=OFF;
CREATE TABLE "new_RawFile" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "file_id" TEXT NOT NULL,
    "full_path" TEXT NOT NULL,
    "workspace_id" TEXT NOT NULL,
    "created_by" TEXT NOT NULL,
    "created_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "updated_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "last_modified_at" DATETIME,
    "file_revision_id" TEXT NOT NULL,
    "size" INTEGER,
    "mime_type" TEXT,
    "hash" TEXT,
    "system" TEXT
);
INSERT INTO "new_RawFile" ("created_at", "created_by", "file_id", "file_revision_id", "full_path", "id", "updated_at", "workspace_id") SELECT "created_at", "created_by", "file_id", "file_revision_id", "full_path", "id", "updated_at", "workspace_id" FROM "RawFile";
DROP TABLE "RawFile";
ALTER TABLE "new_RawFile" RENAME TO "RawFile";
CREATE INDEX "RawFile_workspace_id_idx" ON "RawFile"("workspace_id");
CREATE INDEX "RawFile_file_id_idx" ON "RawFile"("file_id");
CREATE INDEX "RawFile_file_revision_id_idx" ON "RawFile"("file_revision_id");
CREATE INDEX "RawFile_created_by_idx" ON "RawFile"("created_by");
CREATE INDEX "RawFile_created_at_idx" ON "RawFile"("created_at");
CREATE INDEX "RawFile_updated_at_idx" ON "RawFile"("updated_at");
CREATE TABLE "new_RawProject" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "workspace_id" TEXT NOT NULL,
    "full_path" TEXT NOT NULL,
    "project_id" TEXT NOT NULL,
    "system" TEXT NOT NULL,
    "created_by" TEXT NOT NULL,
    "created_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "updated_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP
);
INSERT INTO "new_RawProject" ("id", "workspace_id") SELECT "id", "workspace_id" FROM "RawProject";
DROP TABLE "RawProject";
ALTER TABLE "new_RawProject" RENAME TO "RawProject";
CREATE INDEX "RawProject_project_id_idx" ON "RawProject"("project_id");
CREATE INDEX "RawProject_workspace_id_idx" ON "RawProject"("workspace_id");
CREATE INDEX "RawProject_full_path_idx" ON "RawProject"("full_path");
CREATE INDEX "RawProject_system_idx" ON "RawProject"("system");
CREATE INDEX "RawProject_created_by_idx" ON "RawProject"("created_by");
CREATE INDEX "RawProject_created_at_idx" ON "RawProject"("created_at");
CREATE INDEX "RawProject_updated_at_idx" ON "RawProject"("updated_at");
CREATE TABLE "new_RawWorkspace" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "workspace_id" TEXT NOT NULL,
    "full_path" TEXT NOT NULL,
    "system" TEXT NOT NULL,
    "created_by" TEXT NOT NULL,
    "created_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "updated_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP
);
INSERT INTO "new_RawWorkspace" ("id", "workspace_id") SELECT "id", "workspace_id" FROM "RawWorkspace";
DROP TABLE "RawWorkspace";
ALTER TABLE "new_RawWorkspace" RENAME TO "RawWorkspace";
CREATE INDEX "RawWorkspace_workspace_id_idx" ON "RawWorkspace"("workspace_id");
CREATE INDEX "RawWorkspace_full_path_idx" ON "RawWorkspace"("full_path");
CREATE INDEX "RawWorkspace_system_idx" ON "RawWorkspace"("system");
CREATE INDEX "RawWorkspace_created_by_idx" ON "RawWorkspace"("created_by");
PRAGMA foreign_keys=ON;
PRAGMA defer_foreign_keys=OFF;
`;
